export default angular.module("KhChart",["highcharts-ng"]);